<template>
  <div id="map"></div>
</template>

<script>
/* eslint-disable */

import './stamen'

export default {
  updated () {
    let tN1 = `<div id="bigFont">` + [this.$store.getters.schoolName] + `</div>`
  },
  mounted () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const lat = this.$store.getters.lat
    const lng = this.$store.getters.lng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName
    const inverse = this.$store.getters.inverse
    const sTbM = this.$store.getters.baseOption
    let tN1 = `<div id="bigFont">` + [this.$store.getters.schoolName] + `</div>`

    var layer = new L.StamenTileLayer(sTbM)
    var map = L.map('map', {
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom)
    map.addLayer(layer)

    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 8,
      draggable: true,
      title: name,
      riseOnHover: true
    })
    // map.addLayer(marker)

    var place1 = L.divIcon({
      url: '../../../static/img/ic_gps_fixed_black_24dp_2x',
      // className: 'place-div-icon',
      'draggable': true,
      iconSize: [10, 10],
      iconAnchor: [0, 0],
      popupAnchor: [0, 0]
    })
    var markerP1 = L.marker(latlng, {
      icon: place1
    })
    map.addLayer(markerP1)
    // var marker = L.marker((latlon), { draggable: true }).addTo(map)

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>"

    // end leaflet providers
    // L.control.locate().addTo(map);
    // L.control.zoom({ position: 'bottomleft' }).addTo(map)

    var opacity = 80
    var polygonLayer = r360.leafletPolygonLayer({ inverse: true }).addTo(map)

    let getPolygons = function(){
      polygonLayer.setColors([
          { 'time': seconds[0], 'opacity' : opacity / 100 },
          { 'time': seconds[1], 'opacity' : (opacity / 100) - 0.1 },
          { 'time': seconds[2], 'opacity' : (opacity / 100) - 0.2 }
      ])
      var travelOptions = r360.travelOptions()
      travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH')
      travelOptions.setServiceUrl('https://service.route360.net/na_northeast/')
      travelOptions.addSource(marker)
      travelOptions.setTravelTimes(seconds)
      travelOptions.setTravelType(type)
      r360.PolygonService.getTravelTimePolygons(travelOptions, function(polygons) {
        polygonLayer.setStrokeWidth(pixel)
        polygonLayer.clearAndAddLayers(polygons, true)
      })
    }
    if (inverse === true) {
      getPolygons()
      marker.on('dragend', getPolygons())
    } else {
      var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse })
      map.addLayer(polygonLayer)
      var travelOptions = r360.travelOptions()
      travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH')
      travelOptions.setServiceUrl('https://service.route360.net/na_northeast/')
      travelOptions.addSource(marker)
      travelOptions.setTravelTimes(seconds)
      travelOptions.setTravelType(type)
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel)
        polygonLayer.clearAndAddLayers(polygons, true)
      })
    }
    L.control.scale().addTo(map)
  },
  created () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName
    const sTbM = this.$store.getters.baseOption
  }
}
</script>

<style scoped>
#bigFont {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: white;
}
.btn-title {
  background: repeating-linear-gradient(10deg, #d3d3d3, #7fa995 1px, #96c79d 1px, #b7ce98 1px, #e2ba8b 1px, #dfa38d 1px, #cc8f91 1px);
}
#map{position: absolute;width:100%; z-index:1; top:50px;height:93%;background:#F0E9D8;}

.leaflet-div-icon{
  font-size: 14px;
  padding-top: 25px;
  padding-bottom: 10px;
  padding-left: 4px;
  padding-right: 0px;
  border-radius: 50%;
};
.place-div-icon{
  border: 1px solid black;
  box-sizing: border-box;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 50%;
};
.marker{border:none;cursor:pointer;height:56px;width:56px;background-image:url(../../../static/img/marker-icon.png);background-color:rgba(0,0,0,0)}
.leaflet-control-layers-toggle{background-image:url(../../../static/img/layers.png);width:36px;height:36px}.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/marker-icon-2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/marker-icon-2x.png);background-size:26px 260px}retina .leaflet-control-layers-toggle{background-image:url(../../../static/img/layers-2x.png);background-size:26px 26px}
.leaflet-default-icon-path{background-image:url(../../../static/img/marker-icon.png)}
.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/marker-icon-2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/marker-icon-2x.png);background-size:26px 260px}


.leaflet-default-icon-path {
  background-image:url(../../../static/img/marker-icon.png)
  }

.fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen.png); }
.leaflet-retina .fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen-2x.png); background-size: 26px 26px; }
/* one selector per rule as explained here : http://www.sitepoint.com/html5-full-screen-api/ */
.leaflet-container:-webkit-full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:-ms-fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-pseudo-fullscreen { position: fixed !important; width: 100% !important; height: 100% !important; top: 0px !important; left: 0px !important; z-index: 99999; }

.leaflet-container .leaflet-control-scale{font-size:11px}
.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-moz-box-sizing:content-box;box-sizing:content-box;background:#fff;background:rgba(255,255,255,0.5)}

/* Compatible with Leaflet 0.7 */
.leaflet-control-locate a {
  font-size: 1.4em;
  color: #444;
  cursor: pointer;
}
.leaflet-control-locate.active a {
  color: #2074B6;
}
.leaflet-control-locate.active.following a {
  color: #FC8428;
}
/* Compatible with Leaflet 0.7 */
.leaflet-control-locate a {
  font-size: 1.4em;
  color: #444;
  cursor: pointer;
}
.leaflet-control-locate.active a {
  color: #2074B6;
}
.leaflet-control-locate.active.following a {
  color: #FC8428;
}

/* Mapbox specific adjustments */
.leaflet-control-locate a {
  padding: 3px 0 0 8px;
}
.leaflet-control-locate.requesting a {
  padding: 3px 0 0 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/toolBox/mB3.vue